/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

const es_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio`)
};

const de_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerzeichen`)
};

const nl_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spatie`)
};

const fr_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espace`)
};

const it_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazio`)
};

const pt_br2_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço`)
};

const pt_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço`)
};

const ja_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペース`)
};

const zh_tr_sep_space = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空格`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tr_sep_space = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tr_sep_space(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tr_sep_space", locale)
	if (locale === "en") return en_tr_sep_space(inputs)
	if (locale === "es") return es_tr_sep_space(inputs)
	if (locale === "de") return de_tr_sep_space(inputs)
	if (locale === "nl") return nl_tr_sep_space(inputs)
	if (locale === "fr") return fr_tr_sep_space(inputs)
	if (locale === "it") return it_tr_sep_space(inputs)
	if (locale === "pt-BR") return pt_br2_tr_sep_space(inputs)
	if (locale === "pt") return pt_tr_sep_space(inputs)
	if (locale === "ja") return ja_tr_sep_space(inputs)
	return zh_tr_sep_space(inputs)
};